import Component from "@glimmer/component";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { stringable } from "glesys-controlpanel/utils/prop-types";
import { task } from "ember-concurrency";
import QrCreator from "qr-creator";
import DataLoader from "glesys-controlpanel/components/data-loader";
import { t } from "ember-intl";

@forbidExtraArgs
export default class QrCode extends Component {
  @arg(stringable.isRequired) content;

  createQRCode = task(async () => {
    let container = document.createElement("div");

    QrCreator.render(
      {
        text: this.content,
        radius: 0.5,
        ecLevel: "L",
        size: 300,
        background: "#fff",
      },
      container,
    );

    return container.firstChild.toDataURL();
  });

  <template>
    <DataLoader data-test-qr-code @load={{this.createQRCode}} ...attributes as |qrCode|>
      <img alt={{t "label.qr-code"}} src={{qrCode}} />
    </DataLoader>
  </template>
}
